<template>
    <div>
        <home-header :title="i18n('Dispatching')"></home-header>

        <home-grid dispatching></home-grid>

    </div>
</template>

<script>
    import HomeGrid from "../main/HomeGrid";
    import HomeHeader from "../main/HomeHeader";

    export default {
        components: {
            HomeHeader,
            HomeGrid
        }
    }
</script>

<style></style>
